module.exports = __webpack_public_path__ + "img/qrcode-icon.407dcf2d.png";